import { Button, Group, Stack, Switch, Textarea } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconFileDownload } from "@tabler/icons-react";
import { useComposeFormContext } from "shared/components/message/compose/context";
import { useComposeFormCmSelection } from "shared/components/message/compose/useComposeFormCmSelection";
import { useFormState } from "shared/hooks/useFormState";
import { Cm } from "src/gql/graphql";

export const CustomizationEditor = () => {
    const form = useComposeFormContext();
    const { hasAny } = useComposeFormCmSelection();

    const [smsEnabled, setSmsEnabled] = useFormState(form, "customizations.sms.enabled");
    const [smsBody, setSmsBody] = useFormState(form, "customizations.sms.value");
    const [phoneEnabled, setPhoneEnabled] = useFormState(form, "customizations.phone.enabled");
    const [phoneBody, setPhoneBody] = useFormState(form, "customizations.phone.value");

    return (
        <Stack>
            {hasAny(Cm.Phone) && (
                <Customization
                    label="Customize Voice (Text to Speech)"
                    value={phoneBody}
                    onChange={setPhoneBody}
                    enabled={phoneEnabled}
                    setEnabled={setPhoneEnabled}
                />
            )}

            {hasAny(Cm.Sms) && (
                <Customization
                    label="Customize SMS"
                    value={smsBody}
                    onChange={setSmsBody}
                    enabled={smsEnabled}
                    setEnabled={setSmsEnabled}
                />
            )}
        </Stack>
    );
};

const Customization = (props: {
    label: string;
    enabled: boolean;
    setEnabled?: (enabled: boolean) => unknown;
    value: string;
    onChange?: (value: string) => unknown;
}) => {
    const form = useComposeFormContext();
    const [body] = useFormState(form, "body");

    return (
        <Stack>
            <Group>
                <Switch checked={props.enabled} onChange={(e) => props.setEnabled?.(e.target.checked)} label={props.label} />
                {props.enabled && (
                    <Button
                        variant="transparent"
                        leftSection={<IconFileDownload size={16} />}
                        onClick={() => {
                            if (props.value != "" && props.value != body) {
                                modals.openConfirmModal({
                                    title: "Confirm",
                                    children: "This action will overwrite the customized text. Continue?",
                                    labels: { confirm: "Continue", cancel: "Cancel" },
                                    onConfirm: () => props.onChange?.(body),
                                });
                            } else {
                                props.onChange?.(body);
                            }
                        }}
                    >
                        Use Body
                    </Button>
                )}
            </Group>
            {props.enabled && (
                <Textarea
                    autosize
                    resize="vertical"
                    placeholder="Edit text"
                    value={props.value}
                    onChange={(e) => props.onChange?.(e.target.value)}
                />
            )}
        </Stack>
    );
};
